import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postFileUpload = createApi(`FileUploadSlice`,"POST");

const FileUploadSlice = createSlice({
  name: 'FileUploadSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postFileUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postFileUpload.fulfilled, (state, action) => {
        state.loading = false;
        // state.data = action.payload;
      })
      .addCase(postFileUpload.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload;
      })
  },
});

export default FileUploadSlice.reducer;